"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _layout = require("../layout");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledLayoutBodyCard = (0, _styledComponents.default)(_layout.LayoutBodyCard)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 20px;\n"])));
var Page = function Page(_ref) {
  var FormComponent = _ref.formComponent;
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_layout.LayoutTitle, null, t('confirmPersonal')), /*#__PURE__*/_react.default.createElement(StyledLayoutBodyCard, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(FormComponent, null))));
};
exports.Page = Page;